<template>
  <div class="g-wrapper">
    <div class="g-main">
      <img src="../assets/newsTitle.png" alt="" class="u-newsTitleIcon" />
    </div>
    <div class="g-newsTag">
      <div
        :class="activeIndex == index ? 'm-tagItem active' : 'm-tagItem'"
        v-for="(item, index) in tab"
        :key="index"
        @click="changeIndex(index)"
      >
        {{ item }}
        <span></span>
      </div>
    </div>

    <div class="g-newsList" v-show="activeIndex == 0 || activeIndex == 1">
      <div class="m-newsBox">
        <div class="u-newsBelong">论坛要闻</div>
        <ul class="m-newsList">
          <li v-for="(item, index) in forumNews" :key="index">
            <a :href="item.article_url">
              <img :src="item.thumbnail_url" alt="" />
              <div class="u-newsMsg">
                <p class="u-newsTitle">{{ item.title }}</p>
                <p class="u-newsTime">{{ item.created_at_str }}</p>
              </div>
            </a>
          </li>
        </ul>
        <router-link to="/articleList/1633" class="u-moreNews" v-show="forumNews.length>=10">
          <img src="../assets/icon5.png" alt="" class="u-icon5" />
          查看全部要闻
        </router-link>
      </div>
      <img src="../assets/hr.png" alt="" class="u-hr" />
    </div>
    <div class="g-newsList" v-show="activeIndex == 0 || activeIndex == 2">
      <div class="m-newsBox">
        <div class="u-newsBelong">嘉宾观点</div>
        <ul class="m-newsList">
          <li v-for="(item, index) in forumPoint" :key="index">
            <a :href="item.article_url">
              <img :src="item.thumbnail_url" alt="" />
              <div class="u-newsMsg">
                <p class="u-newsTitle">{{ item.title }}</p>
                <p class="u-newsTime">{{ item.created_at_str }}</p>
              </div>
            </a>
          </li>
        </ul>
        <!-- <div class="u-moreNews">
          <img src="../assets/icon5.png" alt="" class="u-icon5" />
          查看全部要闻
        </div> -->
        <router-link to="/articleList/1634" class="u-moreNews" v-show="forumPoint.length>=10">
          <img src="../assets/icon5.png" alt="" class="u-icon5" />
          查看全部观点
        </router-link>
      </div>
      <img src="../assets/hr.png" alt="" class="u-hr" />
    </div>
    <div class="g-newsList" v-show="activeIndex == 0 || activeIndex == 3">
      <div class="m-newsBox">
        <div class="u-newsBelong">精彩视频</div>
        <ul class="m-newsList">
          <li v-for="(item, index) in forumVideo" :key="index">
            <a :href="item.article_url">
              <img :src="item.thumbnail_url" alt="" />
              <div class="u-newsMsg">
                <p class="u-newsTitle">{{ item.title }}</p>
                <p class="u-newsTime">{{ item.created_at_str }}</p>
              </div>
            </a>
          </li>
        </ul>
        <!-- <div class="u-moreNews">
          <img src="../assets/icon5.png" alt="" class="u-icon5" />
          查看全部要闻
        </div> -->
        <router-link to="/articleList/1635" class="u-moreNews" v-show="forumVideo.length>=10">
          <img src="../assets/icon5.png" alt="" class="u-icon5" />
          查看全部视频
        </router-link>
      </div>
      <img src="../assets/hr.png" alt="" class="u-hr" />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tab: ["全部", "论坛要闻", "嘉宾观点", "精彩视频"],
      activeIndex: 0,
      forumNews: [],
      forumPoint: [],
      forumVideo: [],
    };
  },
  methods: {
    getNews(id, name) {
      let that = this;
      $.ajax({
        url:
          "http://www.nbd.com.cn/columns/" +
          id +
          "/articles_list.json?per=10&page_index=1&simple_info=1",
        methods: "get",
        success: function (data) {
          that[name] = data;
          console.log(that[name]);
        },
      });
    },
    changeIndex(index) {
      this.activeIndex = index;
    },
  },
  mounted() {
    this.getNews(1633, "forumNews");
    this.getNews(1634, "forumPoint");
    this.getNews(1635, "forumVideo");
  },
};
</script>

<style lang="scss" scoped>
.u-newsTitleIcon {
  width: 501px;
  height: 118px;
  display: block;
  margin: 30px auto;
}
.g-newsTag {
  background: url("../assets/tabBg.png") no-repeat;
  background-size: 100% 100%;
  height: 70px;
  padding: 0 40px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  .m-tagItem {
    font-size: 36px;
    color: #333;
    height: 70px;
    line-height: 70px;
    position: relative;
    &.active {
      color: #4383b8;
      span {
        display: inline;
      }
    }
    span {
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 40px;
      height: 4px;
      border-radius: 8px;
      background: #4383b8;
      display: none;
    }
  }
}
.m-newsBox {
  width: 100%;
}
.g-newsList {
  width: 735px;
  margin: 0 auto;
  background: #fff;
  padding: 32px;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;

  &:first-child {
    margin-top: 3px;
  }
}
.u-newsBelong {
  border-left: 8px solid #1298b0;
  font-size: 38px;
  color: #484848;
  padding-left: 20px;
  font-weight: bolder;
}
.m-newsList {
  margin: 0;
  padding: 0;
  li {
    list-style: none;
    margin-top: 35px;
    a {
      display: flex;
      justify-content: space-between;
      text-decoration: none;
      img {
        width: 212px;
        height: 157px;
      }
      .u-newsMsg {
        width: 400px;
        display: inline-flex;
        justify-content: space-between;
        flex-direction: column;
        .u-newsTitle {
          font-size: 28px;
          color: #535353;
          text-align: justify;
        }
        .u-newsTime {
          color: #9e9e9e;
          font-size: 20px;
          text-align: right;
        }
      }
    }
  }
}
.u-moreNews {
  width: 260px;
  height: 45px;
  border: 1px solid #699cc6;
  box-sizing: border-box;
  color: #699cc6;
  font-size: 26px;
  margin: 20px auto;
  text-align: center;
  line-height: 45px;
  display: block;
  text-decoration: none;
  margin: 0 auto;
  margin-top: 60px;
}
.u-icon5 {
  width: 32px;
  height: 22px;
  margin-right: 10px;
}
.u-hr {
  height: 28px;
  display: block;
  margin: 30px -32px;
  width: auto;
}
</style>